import { Loading } from 'element-ui';
// 记录请求次数
let loadingRequestCount = 0;
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    spinner: 'el-icon-loading',
    text: '拼命加载中...',
    background: 'rgba(0, 0, 0, 0.5)',
    customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
  });
}
function endLoading() {
  // 延迟300ms，防止网速特快加载中画面一闪而过
  setTimeout(function () {
    if (loading) loading.close();
  }, 300);
}
// 打开loading
export const showFullScreenLoading = () => {
  if (loadingRequestCount === 0) {
    startLoading();
  }
  loadingRequestCount++;
};
// 关闭loading
export const hideFullScreenLoading = () => {
  if (loadingRequestCount <= 0) return;
  loadingRequestCount--;
  if (loadingRequestCount === 0) {
    endLoading();
  }
};
